import * as React from 'react'
import Button from '@mui/material/Button'
import Swal from 'sweetalert2'

import { useState, useEffect } from 'react'
import axios from 'axios'
import HeaderName from '../../HeaderName'
import SideBar from '../../SideBar.js'
import { useLocation } from 'react-router-dom'

export default function BankInfoDialog(props) {
  const token = localStorage.getItem('token')
  const url = 'http://192.168.1.3:9090/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  const Id = useLocation().pathname.split('/')[2]

  const [unitLists, setUnitLists] = useState([])
  const [type, setType] = useState('')
  const [treatLists, setTreatLists] = useState([])

  const [conValue, setConValue] = useState('')

  const [value, setValue] = useState('')
  const [itemUnitName, setItemUnitName] = useState('')
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [description, setDescription] = useState('')
  const [showValue, setShowValue] = useState(false)
  const [showItem, setShowItem] = useState(false)
  const [faceList, setFaceList] = useState([])
  const [chooseFaceList, setChooseFaceList] = useState([])
  const [showFace, setShowFace] = useState(false)
  const [bodyList, setBodyList] = useState([])
  const [chooseBodyList, setChooseBodyList] = useState([])

  const [showBody, setShowBody] = useState(false)
  const [bodyInjList, setBodyInjList] = useState([])
  const [chooseBodyInjList, setChooseBodyInjList] = useState([])

  const [showBodyInj, setShowBodyInj] = useState(false)
  const [chooseUnitList, setChooseUnitList] = useState([])
  const [showUnit, setShowUnit] = useState(false)
  const [conName, setConName] = useState('')

  //For Con Type
  const handleConType = name => {
    setConName(name)
  }

  //for Unit List
  const handleUnit = Id => {
    console.log(Id, 'Id')
    setChooseUnitList(
      unitLists.filter(
        el => (el.treatmentName ? el.treatmentName._id : '') == Id
      )
    )
    setShowUnit(true)
    console.log(
      unitLists.filter(
        el => (el.treatmentName ? el.treatmentName._id : '') == Id
      ),
      'Final Unit List'
    )
  }
  //If FOCItem , Item
  const handleBodyPart = event => {
    console.log(event, 'Body part')
    if (event == 'Face') {
      setShowFace(true)
      setShowBody(false)
      setShowBodyInj(false)

      setChooseFaceList(faceList)
    }
    if (event == 'Body') {
      setShowBody(true)
      setShowFace(false)
      setShowBodyInj(false)

      setChooseBodyList(bodyList)
    }

    if (event == 'Body Injection') {
      setShowBody(false)
      setShowFace(false)
      setShowBodyInj(true)
      setChooseBodyInjList(bodyInjList)
    }
  }

  //Type
  const handleType = event => {
    setType(event)
    console.log(event, 'Type')
    if (event == 'Amount') {
      setShowValue(true)
      setShowItem(false)
    } else if (event == 'Percentage') {
      setShowValue(true)
      setShowItem(false)
    } else {
      setShowItem(true)
      setShowValue(false)
    }
  }

  //Create
  const DiscountCreate = () => {
    const data = {
      name: name,
      startDate: startDate,
      endDate: endDate,
      type: type,
      description: description
    }

    if (type == 'FOCItem') {
      data.relatedFOCID = itemUnitName
    } else {
      data.value = value
    }
    if (conName == 'Amount') data.conditionAmount = conValue
    if (conName == 'Purchase Freq') data.conditionPurchaseFreq = conValue
    if (conName == 'Package Qty') data.conditionPackageQty = conValue

    // alert(JSON.stringify(data))

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    api
      .post('discount', data, config)
      .then(function (response) {
        Swal.fire({
          title: 'Successful!',
          text: 'You Created Income Data!',
          icon: 'success',
          // showCancelButton: true,

          cancelButtonText: 'Close'
        })

        props.setDisLists([...props.disLists, response.data.data])
      })

      .catch(function (err) {
        Swal.fire({
          title: 'Something Wrong!',
          text: 'Error',
          icon: 'warning',
          // showCancelButton: true,

          cancelButtonText: 'Close'
        })
      })
    props.close()
  }

  useEffect(() => {
    const getTreatmentList = async () => {
      try {
        const res = await api.get('treatment-lists')

        setTreatLists(res.data.list)
        console.log(res.data.list, 'dialog treat list ')
        setFaceList(res.data.list.filter(el => el.bodyParts == 'Face'))
        setBodyList(res.data.list.filter(el => el.bodyParts == 'Body'))
        setBodyInjList(
          res.data.list.filter(el => el.bodyParts == 'Body Injection')
        )
        // console.log(
        //   res.data.list.filter(el => el.bodyParts == 'Body Injection'),
        //   'body inj list'
        // )
      } catch (err) { }
    }
    const getUnitList = async () => {
      try {
        const res = await api.get('treatments')

        setUnitLists(res.data.list)
        console.log(res.data.list, 'unit list')
      } catch (err) { }
    }

    // const getBrandLists = async () => {
    //   try {
    //     const res = await api.get('brands')
    //     setRelatedBrandList(res.data.data)
    //   } catch (err) {
    //     alert(err.message)
    //   }
    // }
    // getCategory()
    getUnitList()

    getTreatmentList()
  }, [])

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>Discount List</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div class='modal-body'>
                <div class='form-group'>
                  <label for='name'>Name</label>
                  <input
                    type='text'
                    class='form-control border border-info'
                    name='name'
                    placeholder='eg. mg mg'
                    onChange={e => setName(e.target.value)}
                  />
                </div>
                <div class='form-group'>
                  <label for='name'>Type</label>
                  <select
                    class='custom-select border-info'
                    name='account_type_id'
                    id='cat'
                    onChange={e => handleType(e.target.value)}
                  >
                    <option hidden>Choose Type</option>

                    <option value='Amount'>Amount</option>
                    <option value='Percentage'>Percent</option>
                    <option value='FOCItem'>FOC Item</option>
                  </select>
                </div>
                {showValue && (
                  <div class='form-group'>
                    <label for='name'>Value</label>
                    <input
                      type='number'
                      class='form-control border border-info'
                      name='name'
                      placeholder='eg. mg mg'
                      onChange={e => setValue(e.target.value)}
                    />
                  </div>
                )}
                {showItem && (
                  <div class='form-group'>
                    <label for='name'>Item</label>
                    <select
                      class='custom-select border-info'
                      id='subCat'
                      name='account_type_id'
                      onChange={e => handleBodyPart(e.target.value)}
                    >
                      <option hidden>Choose Body Parts</option>

                      <option value='Face'>Face</option>
                      <option value='Body'>Body</option>
                      <option value='Body Injection'>Body Injection</option>
                    </select>
                  </div>
                )}
                {showFace && (
                  <div class='form-group'>
                    <label for='name'>Choose Treatment Name</label>
                    <select
                      name='currency'
                      id=''
                      className='form-control mt-1'
                      onchange='convert(this.value)'
                      onChange={e => handleUnit(e.target.value)}
                    >
                      <option hidden>Choose Name</option>

                      {chooseFaceList.map(option => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                {showBody && (
                  <div class='form-group'>
                    <label for='name'>Choose Treatment Name</label>
                    <select
                      name='currency'
                      id=''
                      className='form-control mt-1'
                      onchange='convert(this.value)'
                      onChange={e => handleUnit(e.target.value)}
                    >
                      <option hidden>Choose Name</option>

                      {chooseBodyList.map(option => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                {showBodyInj && (
                  <div class='form-group'>
                    <label for='name'>Choose Treatment Name</label>
                    <select
                      name='currency'
                      id=''
                      className='form-control mt-1'
                      onchange='convert(this.value)'
                      onChange={e => handleUnit(e.target.value)}
                    >
                      <option hidden>Choose Name</option>

                      {chooseBodyInjList.map(option => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {showUnit && (
                  <div class='form-group'>
                    <label for='name'>Choose Treatment Unit Name</label>
                    <select
                      name='currency'
                      id=''
                      className='form-control mt-1'
                      onchange='convert(this.value)'
                      onChange={e => setItemUnitName(e.target.value)}
                    >
                      <option hidden>Choose Name</option>

                      {chooseUnitList.map(option => (
                        <option value={option._id}>{option.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div class='form-group'>
                  <label for='name'>Condition Type</label>
                  <select
                    name='currency'
                    id=''
                    className='form-control mt-1'
                    onchange='convert(this.value)'
                    onChange={e => handleConType(e.target.value)}
                  >
                    <option hidden>Choose Name</option>

                    <option value='Amount'>Amount</option>
                    <option value='Purchase Freq'>Purchase Freq</option>
                    <option value='Package Qty'>Package Qty</option>
                  </select>
                </div>
                <div class='form-group'>
                  <label for='name'>Condition Value</label>
                  <input
                    type='number'
                    class='form-control border border-info'
                    name='name'
                    placeholder='eg. mg mg'
                    onChange={e => setConValue(e.target.value)}
                  />
                </div>

                <div class='form-group'>
                  <label for='name'>Start Date</label>
                  <input
                    type='date'
                    class='form-control border border-info'
                    name='name'
                    placeholder='eg. mg mg'
                    onChange={e => setStartDate(e.target.value)}
                  />
                </div>

                <div class='form-group'>
                  <label for='name'>End Date</label>
                  <input
                    type='date'
                    class='form-control border border-info'
                    name='name'
                    placeholder='eg. mg mg'
                    onChange={e => setEndDate(e.target.value)}
                  />
                </div>
                <div class='form-group'>
                  <label for='name'>Description</label>
                  <textarea
                    className='form-control'
                    id='description'
                    onChange={e => setDescription(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div class='modal-footer'>
                <Button
                  class='btn btn-secondary'
                  data-dismiss='modal'
                  onClick={props.close}
                >
                  Close
                </Button>
                <Button class='btn btn-primary' onClick={DiscountCreate}>
                  Save
                </Button>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer' style={{ marginTop: '50px;' }}>
        <strong>
          Copyright &copy; 2017-2020{' '}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  )
}
// phyo
//maymyat
